import { createRoute } from "../../utils";

import { mediaManagementRoutesObj, mediaBreadcrumbs } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const mediaRouteMetadata: IRouteMetadataObj<typeof mediaManagementRoutesObj> = {
  list: {
    title: "mediaManagement",
    lazy: () => import("@/pages/facultyMemberPanel/media/table/page"),
    mode: "index",
    permission,
  },
  create: {
    title: "addNewNews",
    lazy: () => import("@/pages/facultyMemberPanel/media/form/page"),
    mode: "create",
    permission,
  },
  edit: {
    title: "editNewsOf",
    lazy: () => import("@/pages/facultyMemberPanel/media/form/page"),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewNewsOf",
    lazy: () => import("@/pages/facultyMemberPanel/media/form/page"),
    mode: "view",
    permission,
  },
};

export const mediaRoutes = createRoute<typeof mediaManagementRoutesObj>(
  mediaManagementRoutesObj,
  mediaRouteMetadata,
  mediaBreadcrumbs,
);
